import Step from "./Step";
import {useState, useEffect} from "react";

export default function NameYourFamilyOffice() {
  const [canProceed, setCanProceed] = useState(false);
  useEffect(() => {
    fetch("/api/on_ramp/status")
      .then(response => response.json())
      .then(data => {
        setCanProceed(data.can_start);
      })
      .catch(console.error);
  }, []);

  return <Step index={1} title={"Name your Family Office"}
               canProceed={canProceed}
                busyReason="Loading Transaction Data">
    <p>
      Your family office may be as simple as your family's name, or you may use
      another name that is meaningful to you.
    </p>
    <form>
      <label htmlFor="familyOfficeName" className="form-label">Your Family Office Name</label>
      <input type="text" className="form-control" id="familyOfficeName"/>
    </form>
  </Step>
}